<template>
	<v-row dense>
		<v-col cols="12">
			<v-row dense class="text-md-body-1 text-md-h6">
				<v-col cols="12" sm="4" md="3">
					<v-card class="d-flex align-center py-4" outlined :height="height">
						<v-icon color="green" size="40" class="pa-3">
							far fa-money-bill-alt
						</v-icon>
						<div class="font-weight-400 ml-1 green--text">
							<div>Wholesale value of your order (net)</div>
							<div class="d-flex align-center">
								{{ clientPrice / 100 | euro }}
							</div>
						</div>
					</v-card>
				</v-col>
				<v-col cols="12" sm="4" md="3">
					<v-card class="d-flex align-center py-4" outlined :height="height">
						<v-icon color="black" size="40" class="pa-3">
							fas fa-euro-sign
						</v-icon>
						<div class=" font-weight-400 ml-1">
							<div>Retail value of your order (23% tax incl.)</div>
							<div class="d-flex align-center">
								{{ retailPrice / 100 | euro }}
							</div>
						</div>
					</v-card>
				</v-col>
				<v-col cols="12" sm="4" md="3">
					<v-card class="d-flex align-center py-4" outlined :height="height">
						<v-progress-circular :rotate="270" :size="60" :width="3" :value="missingPercentage"
							color="black" class="ml-2 mr-1 caption">
							<div class="text-no-wrap" v-if="dlFlex">
								-
							</div>
							<div class="text-no-wrap" v-else-if="missing >= 0">
								{{ missing / 100 | euro_small }}
							</div>
							<div class="text-no-wrap" v-else>
								Max DL
							</div>
						</v-progress-circular>
						<div class="font-weight-400 ml-1">
							<div style="display: flex; gap: 4px; flex-wrap: wrap; align-items: center;">
								<span>
									Your Discount Level:&nbsp;{{ activeDl }}
								</span>
								<span v-if="countdownText !== 0 && miniFlex === activeDl" class="ma-0"
									style="width: fit-content; border: 1px solid black; border-radius: 4px; padding: 4px 8px; font-size: 12px; color: red;">
									{{ countdownText }}
								</span>
							</div>
							<div v-if="missing >= 0 && !dlFlex">Next Discount Level:&nbsp;{{ activeDl + 1 }}</div>
						</div>
					</v-card>
				</v-col>
				<v-col cols="12" sm="12" md="3" class="">
					<v-card class="pa-1 d-flex align-center justify-center" outlined
						:height="$vuetify.breakpoint.smAndDown ? 'auto' : height">
						<dialog-summary ref="dialogSummary">
							<template v-slot:activator_section>
								<v-btn color="green" dark class="ma-1" @click="basket" id="order_form-summary_1">
									BASKET
								</v-btn>
							</template>
						</dialog-summary>
						<v-btn color="error" id="order_form-order_now_1" dark class="ma-1 white--text" @click="orderNow"
							:loading="loadingBtnOrderNow">
							ORDER NOW
						</v-btn>
					</v-card>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>
<script>

import DialogSummary from "@/views/Dashboard/Dialog/DialogSummary";

export default {
	name: 'BlockSummary',
	components: { DialogSummary },
	computed: {

		activeDl() {
			return this.$store.getters['DASHBOARD_STORE/ACTIVE_DL'];
		},
		retailPrice() {
			return this.$store.getters['DASHBOARD_STORE/RETAIL_PRICE'];
		},
		clientPrice() {
			return this.$store.getters['DASHBOARD_STORE/CLIENT_PRICE'];
		},
		dls() {
			return this.$store.getters['DASHBOARD_STORE/DLS'];
		},

		dlFlex() {
			return this.$store.getters['AUTH_STORE/DL_FLEX'];
		},

		miniFlex() {
			return this.$store.getters['AUTH_STORE/MINI_FLEX'];
		},

		miniFlexDeadline() {
			return this.$store.getters['AUTH_STORE/MINI_FLEX_END_AT'];
		},

		deadlineInSeconds() {
			if (!this.miniFlexDeadline) return 0;
			return this.miniFlexDeadline > 9999999999
				? Math.floor(this.miniFlexDeadline / 1000)
				: this.miniFlexDeadline;
		},

		secondsLeft() {
			const diff = this.deadlineInSeconds - this.now;
			return diff > 0 ? diff : 0;
		},

		countdownText() {
			if (!this.miniFlexDeadline) return 0;

			const days = Math.floor(this.secondsLeft / (24 * 3600));
			const hours = Math.floor((this.secondsLeft % (24 * 3600)) / 3600);
			const minutes = Math.floor((this.secondsLeft % 3600) / 60);
			const seconds = this.secondsLeft % 60;

			const pad = (num) => String(num).padStart(2, '0');

			if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {

				this.$store.dispatch('AUTH_STORE/refreshDlAfterMiniFlexExpiration')
				this.$store.dispatch('DASHBOARD_STORE/updateProductsPrices')
				return 0;
			}
			if (days > 0) {
				return `${days}d ${pad(hours)}h`;
			}
			return `${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
		},

		missing() {
			let missing = this.dls[this.activeDl] - this.retailPrice;
			return missing >= 0 ? missing : -1;
		},
		missingPercentage() {
			if (this.dlFlex) {
				return 0
			}

			let p = 0;
			let earlierDl = this.dls[this.activeDl - 1] ? this.dls[this.activeDl - 1] : 0;

			p = (this.retailPrice - earlierDl) * 100 /
				(this.dls[this.activeDl] - earlierDl);

			return p < 100 ? p : 100;
		},


		height() {
			if (this.miniFlexDeadline) {
				return 120;
			}
			if (this.$vuetify.breakpoint.xsOnly) {
				return 70;
			} else if (this.$vuetify.breakpoint.mdAndDown) {
				return 85;
			}

			return 120;
		},
	},
	data: () => ({
		loadingBtnOrderNow: false,
		now: Math.floor(Date.now() / 1000),
		timer: null
	}),
	methods: {
		basket() {
			this.$refs.dialogSummary.showDialog()
		},

		orderNow() {
			this.loadingBtnOrderNow = true;
			this.$gtag.event(
				'Custom',
				{
					'klik': 'order_form-order_now',
				}
			)
			this.$store.dispatch('DASHBOARD_STORE/updateBasket')
				.then(() => {
					this.loadingBtnOrderNow = false;
					this.$router.push({ name: 'BasketIndex' })
				})
				.catch(err => {
					console.error(err)
					this.loadingBtnOrderNow = false;
				});
		},
	},
	mounted() {
		this.timer = setInterval(() => {
			this.now = Math.floor(Date.now() / 1000);
		}, 1000);
	},
	beforeDestroy() {
		if (this.timer) {
			clearInterval(this.timer);
		}
	}
};
</script>
